import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

// Haversine distance in km
export function distanceKm(a, b) {
  if (!a || !b) return null;
  const R = 6371;
  const toRad = (x) => (x * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export const FACILITY_META = {
  showers: { label: "Showers", icon: "ShowerHead" },
  toilets: { label: "Toilets", icon: "Bath" },
  electric: { label: "Electric Hookup", icon: "Zap" },
  wifi: { label: "Wi-Fi", icon: "Wifi" },
  shop: { label: "On-site Shop", icon: "ShoppingBag" },
  laundry: { label: "Laundry", icon: "WashingMachine" },
  pool: { label: "Swimming Pool", icon: "Waves" },
  swimming: { label: "Swimming", icon: "Waves" },
  fishing: { label: "Fishing", icon: "Fish" },
  hiking: { label: "Hiking Trails", icon: "Mountain" },
  climbing: { label: "Climbing", icon: "TrendingUp" },
  dog_friendly: { label: "Dog Friendly", icon: "Dog" },
};

// WMO weather code → { label, icon (lucide name) }
export function weatherMeta(code) {
  if (code === 0) return { label: "Clear", icon: "Sun" };
  if (code === 1) return { label: "Mostly clear", icon: "Sun" };
  if (code === 2) return { label: "Partly cloudy", icon: "CloudSun" };
  if (code === 3) return { label: "Overcast", icon: "Cloud" };
  if (code === 45 || code === 48) return { label: "Fog", icon: "CloudFog" };
  if (code >= 51 && code <= 57) return { label: "Drizzle", icon: "CloudDrizzle" };
  if (code >= 61 && code <= 67) return { label: "Rain", icon: "CloudRain" };
  if (code >= 71 && code <= 77) return { label: "Snow", icon: "CloudSnow" };
  if (code >= 80 && code <= 82) return { label: "Rain showers", icon: "CloudRain" };
  if (code === 85 || code === 86) return { label: "Snow showers", icon: "CloudSnow" };
  if (code >= 95) return { label: "Thunderstorm", icon: "CloudLightning" };
  return { label: "—", icon: "Cloud" };
}

export const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/**
 * Expand a campsite returned by `/campsites?slim=true&compact=true`
 * back to full URLs. The backend strips repeated URL prefixes/suffixes
 * to keep Stage 2 payloads small on mobile networks.
 *   image  "u:abc...xyz"  → "https://images.unsplash.com/photo-abc...xyz?w=1200&q=80"
 *   pitchup_url "p:England/.../foo/" → "https://www.pitchup.com/campsites/England/.../foo/"
 */
export function expandCampsiteCompact(s) {
  if (!s) return s;
  const img = s.image;
  if (typeof img === "string" && img.startsWith("u:")) {
    s.image = `https://images.unsplash.com/photo-${img.slice(2)}?w=1200&q=80`;
  }
  const purl = s.pitchup_url;
  if (typeof purl === "string" && purl.startsWith("p:")) {
    s.pitchup_url = `https://www.pitchup.com/campsites/${purl.slice(2)}`;
  }
  return s;
}
